module.exports = __webpack_public_path__ + "img/qrcode-bg.fdc84c77.png";